import * as React from "react";
import {
  FieldArrayWithId,
  UseFieldArrayRemove,
  UseFormGetValues,
  UseFormReturn,
} from "react-hook-form";
import { ProjectFormType } from "../../../../Common/hooks/useCreateProject";
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TableBody,
} from "@mui/material";
import ProjectUserTableRow from "../../../../Common/components/ProjectUserTableRow/ProjectUserTableRow";
import useMultiCollapse from "../../../../Common/hooks/useMultiCollapse";
import styles from "./HeiUserTable.module.scss";

interface HeiUserTableProps {
  fields: FieldArrayWithId<ProjectFormType, "users", "id">[];
  remove: UseFieldArrayRemove;
  getValues: UseFormGetValues<ProjectFormType>;
  useCustomRoleMapping?: boolean;
  form: UseFormReturn<ProjectFormType>;
}

export default function HeiUserTable({
  fields,
  remove,
  getValues,
  useCustomRoleMapping,
  form,
}: HeiUserTableProps) {
  const { ToggleCollapseButton, ToggleItemButton, itemsCollapse } =
    useMultiCollapse(
      () => form.getValues("users").map((_, i) => i),
      true
    );

  const packageId = form.getValues("packageId");

  const handleDelete = React.useCallback(
    (index: number) => {
      remove(index);
    },
    [remove]
  );

  return (
    <Grid item xs={12} sx={{ mb: "40px", mt: "30px" }}>
      <Typography display="inline" variant="h6">
        Users
        <Typography
          display="inline"
          variant={"body1"}
          sx={{ color: "#616161" }}
        >
          ({getValues().users.length})
        </Typography>
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell >
                <b>Name</b>
              </TableCell>
              <TableCell>
                <b>Heiway account</b>
              </TableCell>
              <TableCell>
                <b>Email</b>
              </TableCell>
              <TableCell>
                <b>Role</b>
              </TableCell>
              <TableCell>
                <b>Tools</b>
              </TableCell>
              <TableCell>
                <div className={styles.userDetails__collapseHeaderCell}>
                  <div className={styles.userDetails__tableHeader}></div>
                  <ToggleCollapseButton />
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fields.map((user, index) => {
              const userOpen = itemsCollapse[index];
              return (
                <ProjectUserTableRow
                  key={user.id}
                  user={user}
                  rowIndex={index}
                  handleDelete={handleDelete}
                  packageId={packageId}
                  useCustomRoleMapping={useCustomRoleMapping ?? false}
                  userOpen={userOpen}
                  ToggleItemButton={<ToggleItemButton index={index} />}
                  form={form}
                  userCanEdit={true}
                  isCreateMode={true}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
}
